import { memo } from 'react'

import { faGripLines } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useCueDragHandle } from './cue.dnd.hooks'

/**
 * The grab handle that starts a cue drag.
 *
 * Its own component so that `CueControls` does not depend on drag state; the
 * bindings come from `CueDraggable` through context.
 */
export const CueDragHandle = memo(function CueDragHandle() {
  const { setActivatorNodeRef, listeners } = useCueDragHandle()

  return (
    <button
      ref={setActivatorNodeRef}
      {...listeners}
      className="flex-none w-7 h-7 opacity-0 group-hover:opacity-70 hover:opacity-100! cursor-grab! rounded-sm focus:outline-hidden focus:ring-3"
    >
      <FontAwesomeIcon icon={faGripLines} />
    </button>
  )
})
